module.exports = __webpack_public_path__ + "static/img/img_slogn.c475974d.png";